/**
 * ログイン画面
 */

import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Paper,
  Title,
  TextInput,
  PasswordInput,
  Button,
  Stack,
  Alert,
  Text,
  Badge,
  Group,
} from "@mantine/core";
import { useAuth } from "../hooks/useAuth";

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn, loading, error, isEmulator } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // リダイレクト先を取得
  const from = (location.state as { from?: Location })?.from?.pathname || "/dashboard";

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const success = await signIn(email, password);
    if (success) {
      navigate(from, { replace: true });
    }

    setIsSubmitting(false);
  };

  return (
    <Container size={420} my={80}>
      <Title ta="center" mb="md">
        IBS OCR
      </Title>

      {isEmulator && (
        <Group justify="center" mb="md">
          <Badge color="yellow" variant="filled">
            Emulator 環境
          </Badge>
        </Group>
      )}

      <Paper withBorder shadow="md" p={30} radius="md">
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            {error && (
              <Alert color="red" title="エラー">
                {error}
              </Alert>
            )}

            <TextInput
              label="メールアドレス"
              placeholder="admin@example.com"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              disabled={isSubmitting || loading}
            />

            <PasswordInput
              label="パスワード"
              placeholder="パスワード"
              required
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              disabled={isSubmitting || loading}
            />

            <Button type="submit" fullWidth loading={isSubmitting || loading}>
              ログイン
            </Button>
          </Stack>
        </form>

        {isEmulator && (
          <Text size="xs" c="dimmed" mt="md" ta="center">
            Emulator: yarn seed でテストユーザーを作成できます
          </Text>
        )}
      </Paper>
    </Container>
  );
}
